import { Component, OnInit, Injector, Output, EventEmitter, Input } from '@angular/core';
import { FormComponent } from '../../forms/form.component';
import { ActivatedRoute } from '@angular/router';
import { FormFieldState } from '../../forms/form-field/data/form-field-state';
import { FormSettings } from '../../forms/form-settings';
import { FileDto } from '../../base-types';

@Component({
  selector: 'app-input-bar',
  templateUrl: './input-bar.component.html',
  styleUrls: ['./input-bar.component.scss']
})
export class InputBarComponent extends FormComponent {

  @Input() set successfulMessageSending(value:boolean) {
    console.log('InputBarComponent successfulMessageSending :>> ', value);
    if(value!=null){
      this.formSubmitting = false;
      this.removeReadOnly();
     
      if(value)
        this.clearForm();
    }
  }

  @Output() modelChange: EventEmitter<FormFieldState> = new EventEmitter<FormFieldState>(); //evento emesso ad ogni modifica del model 
  @Output() messageSending: EventEmitter<string> = new EventEmitter<string>(); //evento emesso al submit (contenente il messaggio da inviare)

  constructor(
    private _route: ActivatedRoute,
    protected _injector: Injector
  ) {
    super(_injector);

    window.scroll(0, 0); //TODO: capire se serve
  }

  /** @override */
  async init() {
    await super.init()
    // if(this.securityDataService.userProfile.authorities.includes('IAM__ROLES__EDIT'))
    //   this.authorizedActions.push('SAVE')
    // if(this.securityDataService.userProfile.authorities.includes('IAM__ROLES__DELETE'))
    //   this.authorizedActions.push('DELETE')
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.focus("message")
  }

  /** @override */
  async updateCurrentValue(fieldId: string, event: any) {
    super.updateCurrentValue(fieldId, event);

    this.modelChange.emit(this.currentFormState[fieldId])
  }

  /** @override */
  async submit(): Promise<void | 'VALIDATION_ERROR' | 'JUICE_SERVER_ERROR' | 'GENERIC_ERROR'> {
    super.submit();
    this.messageSending.emit(this.currentValues["message"] as string)
    this.focus("message")
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        message: {
          placeholder: 'CHAT.TYPE_A_MESSAGE'
        }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {
      message: null
    }
  }

  /** @override */
  protected _submitHook() {
    throw new Error("Method not implemented.");
  }

}